import {
  Flex,
  IconButton,
  Tooltip,
  Button,
  DropdownMenu,
} from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';

const ActionButtons = ({
  isEditing,
  onSave,
  onCancel,
  onEdit,
  onCopy,
  onDelete,
}) => {
  const { t } = useTranslation('goals');

  return (
    <Flex align="center" justify="end" gap="3">
      {isEditing ? (
        <>
          <Tooltip content={t('actionButtons.save')}>
            <Button size="2" variant="solid" onClick={onSave}>
              {t('actionButtons.save')}
            </Button>
          </Tooltip>
          <Tooltip content={t('actionButtons.cancel')}>
            <IconButton
              variant="outline"
              size="2"
              color="gray"
              onClick={onCancel}
            >
              <i className="fa-light fa-xmark fa-lg" />
            </IconButton>
          </Tooltip>
        </>
      ) : (
        <>
          <Tooltip content={t('actionButtons.edit')}>
            <IconButton
              variant="outline"
              size="2"
              color="gray"
              onClick={onEdit}
            >
              <i className="fa-light fa-pen-to-square fa-lg" />
            </IconButton>
          </Tooltip>
          <DropdownMenu.Root>
            <Tooltip content={t('actionButtons.moreOptions')}>
              <DropdownMenu.Trigger>
                <IconButton variant="outline" size="2" color="gray">
                  <i className="fa-light fa-ellipsis-vertical fa-lg" />
                </IconButton>
              </DropdownMenu.Trigger>
            </Tooltip>
            <DropdownMenu.Content>
              <DropdownMenu.Item onClick={onCopy}>
                <i
                  className="fa-light fa-copy fa-sm"
                  style={{ marginRight: '8px' }}
                />
                {t('actionButtons.duplicate')}
              </DropdownMenu.Item>
              <DropdownMenu.Separator />
              <DropdownMenu.Item onClick={onDelete} color="red">
                <i
                  className="fa-light fa-trash fa-sm"
                  style={{ marginRight: '8px' }}
                />
                {t('actionButtons.delete')}
              </DropdownMenu.Item>
            </DropdownMenu.Content>
          </DropdownMenu.Root>
        </>
      )}
    </Flex>
  );
};

export default ActionButtons;
